import React, { FC } from "react";
import { HeroPrice, HeroPriceProps } from "./HeroPrice";
import { VolvatOptimizelyProvider } from "../Optimizely/VolvatOptimizelyProvider";

export const HeroPriceProvider: FC<HeroPriceProps> = ({
  priceText,
  fontColor,
  optimizelyExperimentation,
}) => {
  return (
    <VolvatOptimizelyProvider sdkKey={optimizelyExperimentation.sdkKey}>
      <HeroPrice
        priceText={priceText}
        fontColor={fontColor}
        optimizelyExperimentation={optimizelyExperimentation}
      />
    </VolvatOptimizelyProvider>
  );
};
